import Model from "../Model";

export interface TPublicationsReportRecord {
  additionalEvaluationDate: Date;
  additionalEvaluationIndicator: boolean;
  additionalEvaluationStatus: string;
  applicantId: number;
  fatherName: string;
  formalEvaluationDate: Date;
  formalEvaluationStatus: string;
  maidenName: string;
  name: string;
  partyId: number;
  reportingPeriodId: number;
  reportingPeriodName: string;
  submitDate: Date;
  surname: string;
  version: number;
}

export interface IPublicationsReportRecord extends TPublicationsReportRecord {}

const PublicationsReportRecord = Model(
  (model: TPublicationsReportRecord): IPublicationsReportRecord => {
    const _publicationsReportRecord: TPublicationsReportRecord = Object.assign(
      {},
      model
    );

    return {
      get additionalEvaluationDate() {
        return _publicationsReportRecord.additionalEvaluationDate;
      },
      set additionalEvaluationDate(value) {
        _publicationsReportRecord.additionalEvaluationDate = value;
      },
      get additionalEvaluationIndicator() {
        return _publicationsReportRecord.additionalEvaluationIndicator;
      },
      set additionalEvaluationIndicator(value) {
        _publicationsReportRecord.additionalEvaluationIndicator = value;
      },
      get additionalEvaluationStatus() {
        return _publicationsReportRecord.additionalEvaluationStatus;
      },
      set additionalEvaluationStatus(value) {
        _publicationsReportRecord.additionalEvaluationStatus = value;
      },
      get applicantId() {
        return _publicationsReportRecord.applicantId;
      },
      set applicantId(value) {
        _publicationsReportRecord.applicantId = value;
      },
      get fatherName() {
        return _publicationsReportRecord.fatherName;
      },
      set fatherName(value) {
        _publicationsReportRecord.fatherName = value;
      },
      get formalEvaluationDate() {
        return _publicationsReportRecord.formalEvaluationDate;
      },
      set formalEvaluationDate(value) {
        _publicationsReportRecord.formalEvaluationDate = value;
      },
      get formalEvaluationStatus() {
        return _publicationsReportRecord.formalEvaluationStatus;
      },
      set formalEvaluationStatus(value) {
        _publicationsReportRecord.formalEvaluationStatus = value;
      },
      get maidenName() {
        return _publicationsReportRecord.maidenName;
      },
      set maidenName(value) {
        _publicationsReportRecord.maidenName = value;
      },
      get name() {
        return _publicationsReportRecord.name;
      },
      set name(value) {
        _publicationsReportRecord.name = value;
      },
      get partyId() {
        return _publicationsReportRecord.partyId;
      },
      set partyId(value) {
        _publicationsReportRecord.partyId = value;
      },
      get reportingPeriodId() {
        return _publicationsReportRecord.reportingPeriodId;
      },
      set reportingPeriodId(value) {
        _publicationsReportRecord.reportingPeriodId = value;
      },
      get reportingPeriodName() {
        return _publicationsReportRecord.reportingPeriodName;
      },
      set reportingPeriodName(value) {
        _publicationsReportRecord.reportingPeriodName = value;
      },
      get submitDate() {
        return _publicationsReportRecord.submitDate;
      },
      set submitDate(value) {
        _publicationsReportRecord.submitDate = value;
      },
      get surname() {
        return _publicationsReportRecord.surname;
      },
      set surname(value) {
        _publicationsReportRecord.surname = value;
      },
      get version() {
        return _publicationsReportRecord.version;
      },
      set version(value) {
        _publicationsReportRecord.version = value;
      }
    };
  }
);

export default PublicationsReportRecord;
